import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Navbar from '../navbar/Navbar'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import Footer from '../footer/footer'
import { Link } from "react-router-dom";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function ControlledExpansionPanels() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <div className={classes.root}>
            <Navbar />
            <Link id='back' to="/QuestionBank">
                <Button style={{ margin: '10px', marginTop: '70px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
            <h1 id='desc' style={{ textAlign: 'center' }}>Fourth sem CSE/ISE QB</h1>


            <ExpansionPanel expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ marginTop: '40px' }}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography className={classes.heading}>Mathematics 4</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question bank <br />
                        <a href="https://drive.google.com/file/d/1xWfpM269QCDsx0KdLxi52NHX9Mr9eQom/view?usp=sharing"> Module 1 </a> <br/>
                        <a href="https://drive.google.com/file/d/13RTX2R4agUQOsOBxU5BoGf3VdDovGYWx/view?usp=sharing"> Module 2 </a> <br/>
                        <a href="https://drive.google.com/file/d/1lYljn2_qJ1fOehccPu-IVITPMcJ132x6/view?usp=sharing"> Module 3 </a> <br/>
                        <a href="https://drive.google.com/file/d/1fvZmOYx_KJlwvuf0yabNP3ph9gyph8z3/view?usp=sharing"> Module 4 </a> <br/>
                        <a href="https://drive.google.com/file/d/1PgiYdpzYGSDo81eMcI4BfOOHgM07Ot1y/view?usp=sharing"> Module 5 </a> <br/>
                        <a href="https://drive.google.com/file/d/1IpcdzKuQJzPJmVN9AThKdvTvNnVG5IIo/view?usp=sharing"> Model QP</a> <br/>

                        </div>
                    </Typography>

                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1aMViOZS0c5zl9TTRHP-f_VVMc65sieYI/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1XtpVrb8XGFv3fBB7ri4jweVYNr_ZHeZi/view?usp=sharing">
                Dec 2018/2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1YMk_-Z58aPRl45UNA_cYlQjQWG82uocz/view?usp=sharing">
                June 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1PiV_1u1Rr94wn89UMAsToFyWQd4Avq6u/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1r50QJWgQ3ZTk58WkAJ7FUCOkqgErwYVF/view?usp=sharing"
                target="_blank"
              >
                June 2019
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>Software Engineering</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                        <a href="https://drive.google.com/file/d/1gNbuhkYPQDLEJSp2hdPRlE-fJTRNpikT/view?usp=sharing"> Module 1 </a> <br/>
                <a href="https://drive.google.com/file/d/1atmIOvttYGvMpKmMPASA5a0QaynPRxmF/view?usp=sharing"> Module 2 </a> <br/>
                <a href="https://drive.google.com/file/d/1THl1YJc1X-kZ6Ca0Bj7F--1EOxf4kwrN/view?usp=sharing"> Module 3 </a> <br/>
                <a href="https://drive.google.com/file/d/152JeQNiRkA2xY5tnRZwD3x06_7uKZvC7/view?usp=sharing"> Module 4 </a> <br/>
                <a href="https://drive.google.com/file/d/1dJhDhGOiUe33Hu9Vscy1LT_ZGLex5Fkp/view?usp=sharing"> Module 5 </a> <br/>
                           
                        </div>

                    </Typography>

                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/15VDeKpifx5rOjwwYRfvpH8m7m7RR9YyB/view?usp=sharing">
                Dec 2017/2018
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1_cXWJCDvYd7EMABeuaWskfcVyv3a-5xT/view?usp=sharing">
                Dec 2018/2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1GvcW5TfZZXE89X0LBaEMNviCdH6DmLWO/view?usp=sharing">
                June 2017/2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1Azp5f-kvl0RhL6ErAZw2vJPrQ6212eMq/view?usp=sharing"
                target="_blank"
              >
                June 2018/2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/13iuGbzCwCQVnBL0t8-lfhEUaI2f36xBO/view?usp=sharing"
                target="_blank"
              >
                June 2019
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>DAA</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                        <a href="https://drive.google.com/file/d/1dQofXNOI_4rnhpKUGZlYjW8e_991wffu/view?usp=sharing"> Module 1 </a> <br/>
                        <a href="https://drive.google.com/file/d/10eTTpmlf1-79_bmzJZ5QgmUK86rwr7Xn/view?usp=sharing"> Module 2 </a> <br/>
                        <a href="https://drive.google.com/file/d/1RhymNVQHYGb18ijzHXVLOwG1ftRs9t_0/view?usp=sharing"> Module 3 </a> <br/>
                        <a href="https://drive.google.com/file/d/19xe6YjwlE8uuVOs56KzaBAJnK3o9F37r/view?usp=sharing"> Module 4 </a> <br/>
                        <a href="https://drive.google.com/file/d/1UHGTRsTotCPPYqLClV8tviP034SfLaby/view?usp=sharing"> Module 5 </a> <br/>
                           
                        </div>
                    </Typography>

                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/16HbMddwF1mIb3TwiE9yGbTFETgaI_5SM/view?usp=sharing">
                Dec 2017/2018
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1iEMoOOR4SI8UJ7n2n9mtdBlsMgaheZr9/view?usp=sharing">
                Dec 2018/2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1Sov7wp974LmvXuCaBs-G1yiMnflNOxNc/view?usp=sharing">
                June 2017/2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1S3_VM3fZhPKrf_bNw0MLTNuYpTqpoGK4/view?usp=sharing"
                target="_blank"
              >
                June 2018/2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1iEMoOOR4SI8UJ7n2n9mtdBlsMgaheZr9/view?usp=sharing"
                target="_blank"
              >
                June 2019
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Micro Processor</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Not Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}>
                           
                        </div>
                    </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>OOPS</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}> Question Bank <br/>
                        <a href="https://drive.google.com/file/d/1FemL6SwVF3cfTBLOkfgQ6QFPLOxHKbsi/view?usp=sharing"> Module 1 </a> <br/>
                        <a href="https://drive.google.com/file/d/1ibsMaShKkrP4taWq26LePcKsPwI183vD/view?usp=sharing"> Module 2 </a> <br/>
                        <a href="https://drive.google.com/file/d/1ExUs-ylKudZRsvKzEhnddEjQmlZIz6HS/view?usp=sharing"> Module 3 </a> <br/>
                        <a href="https://drive.google.com/file/d/1TJBYBEnton3N-pThQyXJOG0fHGRvrmF4/view?usp=sharing"> Module 5 </a> <br/>
                           
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/14Z4aTscdEJzk-rhNnpqzI_tY56GO1kK6/view?usp=sharing">
                June 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1sFDn0aYVrrQlSoXyYD0afoTBShsC96rs/view?usp=sharing">
                Dec 2018/2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1ZPZqempkxKk1jIMV9DG5KXibBERjd8Y9/view?usp=sharing">
                Jan 2019
              </a>
              <br />
             
              <a
                href="https://drive.google.com/file/d/14Z4aTscdEJzk-rhNnpqzI_tY56GO1kK6/view?usp=sharing"
                target="_blank"
              >
                June 2017
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>Data Communication</Typography>
                    <Typography style={{ marginLeft: '30px' }} className={classes.secondaryHeading}>Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}>
                            Question Bank <br />
                <a href="https://drive.google.com/file/d/118f6pQuAx06JYJeePd46GOTqlE06NNyp/view?usp=sharing"> Module 1 </a> <br/>
                <a href="https://drive.google.com/file/d/1wb3_JaObXYmdpUBLj87NH7LINhC0_apP/view?usp=sharing"> Module 2 </a> <br/>
                <a href="https://drive.google.com/file/d/15a38HNFIw9EoTfpVGLFCHDnsIlt0sRkN/view?usp=sharing"> Module 3 </a> <br/>
                <a href="https://drive.google.com/file/d/1FAqzqfnVnBtgA4IGQTCg74QrCeRneSNx/view?usp=sharing"> Module 4 </a> <br/>
                <a href="https://drive.google.com/file/d/1gYeYBmReXkyzaiOzjYFy-hyGic1hstpQ/view?usp=sharing"> Module 5 </a> <br/>
                           
                        </div>
                    </Typography>
                    <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1IB40G5BVkXw_gpHkez5gO7U8LqZLAgD7/view?usp=sharing">
                Dec 2017/2018
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1PgcHhgorSLx_k8bdPvPN_yqKFRaGUZ3C/view?usp=sharing">
                Dec 2018/2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1x64cmSh5l3rn9RJghpStMOlITOFcZ-ap/view?usp=sharing">
                June 2017/2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1pO1gU0J6aZJr8Hn1Uohgdp0dJ9kkSfuD/view?usp=sharing"
                target="_blank"
              >
                June 2018/2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/19v001MXhZYBVNJX3Xqnt6f82tF3oMGbC/view?usp=sharing"
                target="_blank"
              >
                June 2019
              </a>
              <br />
             
            </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>
         

            <Footer />

        </div>
    );
}
